var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "product-by-length" } },
    [
      _c(
        "b-row",
        { staticClass: "mb-3" },
        [
          _c(
            "b-col",
            { attrs: { md: "6" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: "Select a number of metres:",
                    "label-size": "lg",
                  },
                },
                [
                  _c("b-form-radio-group", {
                    staticClass: "pl-4",
                    attrs: {
                      size: "lg",
                      stacked: "",
                      options: _vm.packTypeOptions,
                    },
                    model: {
                      value: _vm.packType,
                      callback: function ($$v) {
                        _vm.packType = $$v
                      },
                      expression: "packType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                { attrs: { label: "Quantity:", "label-size": "lg" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      type: "number",
                      number: "",
                      step: "1",
                      size: "lg",
                      min: "1",
                    },
                    model: {
                      value: _vm.quantity,
                      callback: function ($$v) {
                        _vm.quantity = $$v
                      },
                      expression: "quantity",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-overlay",
                { attrs: { show: _vm.loadingPrice || _vm.loadingStock } },
                [
                  _c("p", { staticClass: "mb-1" }, [
                    _c("strong", [_vm._v("Pack Type:")]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.packType == "length" ? "Single Length" : "Box"
                        )
                    ),
                  ]),
                  _c("p", [
                    _c("strong", [_vm._v("Quantity:")]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.quantity) +
                        " at £" +
                        _vm._s(_vm.pricing.unit_price)
                    ),
                  ]),
                  !_vm.product.discontinued_at || _vm.isAdmin
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mb-3",
                          attrs: {
                            variant: _vm.buyButtonVariant,
                            disabled: _vm.isAddToCartDisabled,
                            size: "lg",
                            block: "",
                          },
                          on: { click: _vm.addToCart },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("shopping_cart"),
                          ]),
                          _vm._v(
                            "Add to Cart (£" +
                              _vm._s(_vm.pricing.total_price) +
                              " " +
                              _vm._s(_vm.vatMode) +
                              " VAT)"
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.product.discontinued_at
                    ? _c("product-discontinued", {
                        attrs: { replacement: _vm.product.replacement },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }